import { TABLE_URI_ADDON } from '../../../constants/constant';
import { ALLOWED_FEATURE_KEYS } from '../../../constants/section-constants/common-constants';
import { TABLES } from '../../../constants/section-constants/eventify-constant';
import {
  getRequest,
  postRequest,
  deleteRequest,
  patchRequest
} from '../../Common/network-call';

export const FETCH_APP_USERS_ALL_NOTES = 'FETCH_APP_USERS_ALL_NOTES';
export const OPEN_NOTE_DETAILS = 'OPEN_NOTE_DETAILS';
export const SHOW_BACK_NOTES_SCREEN = 'SHOW_BACK_NOTES_SCREEN';
export const FETCH_APP_USER_NOTES = 'FETCH_APP_USER_NOTES';

// actions with API Calls
export const fetchAppUserNotesOfNotes = (
  session,
  searchText = '',
  callback
) => {
  let filter = encodeURI(
    `(eventid=${session.eventid})AND(appuserid=${session.userid})AND(note CONTAINS ${searchText})`
  );
  let orderby = 'updatedon%20DESC';
  let related =
    'appuser_by_attendeeid,exhibitors_by_exhibitorid,sponsor_by_sponsorid,speaker_by_speakerid';

  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.appuserNotes}?related=${related}&include_count=true&filter=(${filter})&order=${orderby}`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        dispatch({
          type: FETCH_APP_USERS_ALL_NOTES,
          payload: { data: data.resource, count: data.meta.count }
        });
        callback({
          success: 1,
          result: { response: data.resource }
        });
      },
      error => {
        callback({ success: 0, error: error });
      }
    );
  };
};

export const fetchAppUserNotes = (session, key, id, callback) => {
  const ALLOWED_KEYS = {
    [ALLOWED_FEATURE_KEYS.exhibitor]: 'exhibitorid',
    [ALLOWED_FEATURE_KEYS.sponsor]: 'sponsorid',
    [ALLOWED_FEATURE_KEYS.speaker]: 'speakerid',
    [ALLOWED_FEATURE_KEYS.attendee]: 'attendeeid'
  };

  const filter = encodeURI(
    `(eventid=${session.eventid})AND(appuserid=${session.userid})AND(${ALLOWED_KEYS[key]}=${id})`
  );

  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.appuserNotes}?include_count=true&filter=(${filter})`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        dispatch({
          type: FETCH_APP_USER_NOTES,
          payload: { data: data.resource, count: data.meta.count }
        });
        callback({
          success: 1,
          result: { response: data.resource, count: data.meta.count }
        });
      },
      error => {
        callback({ success: 0, error: error });
      }
    );
  };
};

export const clearAppUserNotes = () => {
  return dispatch => {
    dispatch({
      type: FETCH_APP_USER_NOTES,
      payload: {}
    });
  };
};

export const clearAppUserAllNotes = () => {
  return dispatch => {
    dispatch({
      type: FETCH_APP_USERS_ALL_NOTES,
      payload: {}
    });
  };
};

export const addUpdateNote = (session, payloadObj, updateID, callback) => {
  if (_.isEmpty(payloadObj)) return dispatch => {};

  const tableUrl = `${session.instance_url}${TABLE_URI_ADDON}/${
    TABLES.appuserNotes
  }${updateID ? `/${updateID}` : ''}`;
  const payloadBody = !updateID ? { resource: [payloadObj] } : payloadObj;

  return dispatch => {
    if (!updateID)
      postRequest(
        tableUrl,
        payloadBody,
        session,
        dispatch,
        response => {
          callback({ success: 1, response: response.resource[0] });
        },
        error => {
          callback({ success: 0, error: error });
        }
      );
    else
      patchRequest(
        tableUrl,
        payloadBody,
        session,
        dispatch,
        response => {
          callback({ success: 1 });
        },
        error => {
          callback({ success: 0, error: error });
        }
      );
  };
};

export const deleteNote = (session, noteid, callback) => {
  let filter = encodeURI(
    `(eventid=${session.eventid})AND(appuserid=${session.userid})AND(id=${noteid})`
  );
  const url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.appuserNotes}?filter=(${filter})`;
  return dispatch => {
    deleteRequest(
      url,
      session,
      dispatch,
      response => {
        callback({ success: 1, response });
      },
      error => {
        callback({ success: 0, error });
      }
    );
  };
};

// actions w/o network calls
export const openNoteDetails = noteData => {
  return dispatch => {
    dispatch({ type: OPEN_NOTE_DETAILS, payload: noteData });
  };

  /**
   * Blank set obj: { show: false }
   * Value object:
   * {
        show: true,
        type: 'add' | 'update',
        value: {
          id: Null | Number,
          note: Null | String,
          image: Null | String,
          appuser_by_attendeeid: Null | JSON,
          exhibitors_by_exhibitorid: Null | JSON,
          speaker_by_speakerid: Null | JSON,
          sponsor_by_sponsorid: Null | JSON,
          ...
        },
        notesOn: { 
          associated: Null | Number,
          type: 'attendee' | 'exhibitor' | 'speaker' | 'sponsor',
          name: Null | String,
        }
      }
   */
};

export const showBackNotesScreen = toggle => {
  return dispatch => {
    dispatch({ type: SHOW_BACK_NOTES_SCREEN, payload: toggle });
  };
};
